module.exports = __webpack_public_path__ + "static/media/share.cc49b273.svg";